import api from './axios';

/**
 * Helpdesk (spec §11).
 *
 * A member's thread excludes internal admin notes server-side — the SPA never
 * receives them, so there is nothing to filter here.
 */
export const listTickets      = (params = {})        => api.get('/v1/support/tickets', { params });
export const createTicket     = (payload)            => api.post('/v1/support/tickets', payload);
export const setTicketStatus  = (ticketId, status)   => api.post(`/v1/support/tickets/${ticketId}/status`, { status });

/**
 * One page of a conversation, newest batch first.
 *
 * `before_id` walks backwards through the history — the request with none asks
 * for the latest batch and is the only one that carries the ticket header.
 */
export const getTicketThread = (ticketId, { beforeId, limit } = {}) =>
  api.get(`/v1/support/tickets/${ticketId}/messages`, {
    params: {
      ...(beforeId ? { before_id: beforeId } : {}),
      ...(limit ? { limit } : {}),
    },
  });

/**
 * Posts a reply, as multipart when there is a file and plain JSON otherwise.
 *
 * The switch matters: sending every reply as multipart would make the common
 * case (a line of text) carry a boundary-encoded body for no reason, and axios
 * sets the Content-Type from the FormData itself — hand-setting it drops the
 * boundary and the server sees an empty body.
 */
export const replyToTicket = (ticketId, { text, isInternal, attachment } = {}) => {
  const path = `/v1/support/tickets/${ticketId}/messages`;

  if (!attachment) {
    return api.post(path, {
      text,
      ...(isInternal === undefined ? {} : { is_internal: isInternal }),
    });
  }

  const form = new FormData();
  form.append('text', text);
  if (isInternal !== undefined) form.append('is_internal', isInternal ? '1' : '0');
  form.append('attachment', attachment);

  return api.post(path, form);
};

/** A short-lived link to one message's attachment — re-authorised per request. */
export const getMessageAttachment = (ticketId, messageId) =>
  api.get(`/v1/support/tickets/${ticketId}/messages/${messageId}/attachment`);

/** Moves the caller's read watermark to the newest message they can see. */
export const markTicketRead = (ticketId) =>
  api.post(`/v1/support/tickets/${ticketId}/read`, {});

/** Drives the nav badge — its own route so the shell need not pull a ticket page. */
export const getSupportUnread = () => api.get('/v1/support/unread');

/**
 * Puts a ticket in one agent's hands, or hands it back to the pool.
 *
 * `assignedTo: null` unassigns — sent explicitly rather than omitted, so the
 * audit row records the hand-back as a deliberate act.
 */
export const assignTicket = (ticketId, assignedTo) =>
  api.post(`/v1/support/tickets/${ticketId}/assign`, { assigned_to: assignedTo });
